import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import GeneralForm from '../../components/generalForm';
import { useDriver, useDriverCreate, useDriverEdit } from './apiHooks';
import utils from '../../utils/utils';
import CustomSelect from '../../components/customFields/customSelect';

function DriverForm({ intl, driverId, onSuccess }) {
  const [formDriver, setFormDriver] = useState({});

  const {
    isLoading: loading,
    isError,
    error,
  } = useDriver({
    driverId: driverId,
    onSuccess: (driver) => setFormDriver(driver),
  });

  const {
    editDriver,
    isLoading: editLoading,
    isError: isEditError,
    error: editError,
  } = useDriverEdit(() => {
    onSuccess();
  });

  const {
    createDriver,
    isLoading: createLoading,
    isError: isCreateError,
    error: createError,
  } = useDriverCreate(() => onSuccess());

  const formSchema = {
    type: 'object',
    required: [],
    properties: {
      name: {
        type: 'string',
        title: intl.formatMessage({ id: 'driver.form.field.name.label' }),
      },
      phoneNumber: {
        type: 'string',
        title: intl.formatMessage({ id: 'driver.form.field.phone.label' }),
      },
    },
  };

  const uiSchema = {
    vehicleType: {
      'ui:field': 'customSelect',
    },
  };

  const onFormSubmit = () => {
    try {
      if (driverId) {
        editDriver({ driver: formDriver });
      } else {
        createDriver({ driver: formDriver });
      }
    } catch (e) {
      window.scrollTo(0, 0);
    }
  };

  const formFields = {
    customSelect: CustomSelect,
  };

  const buttonCopy = driverId ? 'driver.edit.form.submit' : 'driver.create.form.submit';

  return (
    <div className="m-b-6">
      <GeneralForm
        title={
          driverId
            ? intl.formatMessage({ id: 'driver.edit.header' }, { driverId })
            : intl.formatMessage({ id: 'driver.create.header' })
        }
        onChange={(event) => setFormDriver(event.formData)}
        onSubmit={onFormSubmit}
        formSchema={formSchema}
        formUiSchema={uiSchema}
        formFields={formFields}
        formData={formDriver}
        buttonCopy={buttonCopy}
        errorMessage={
          isError || isEditError || isCreateError
            ? utils.getErrorMessageFromResponse(error || editError || createError, true)
            : null
        }
        loading={loading || editLoading || createLoading}
        hideImageUpload={true}
      />
    </div>
  );
}

DriverForm.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

const mapDispatchToProps = {};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(DriverForm));
